(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["add-to-cart-code"]) return;
  try {
    

	$(document).ready(function() {
		$.fn.showDone = function() {
			alert("hello");
		}
		 $(".add-button").click(function() {
			var prdtid = $('#productId').val();
			var prdtname = $('#productName').val();
			var prdtqty = $('#productQuantity').val();

			var data = {
			    'product_id': productId,
    			'product_name': productName,
   			    'quantity': productQuantity
			};
			   $.post("/cart/add", data, showDone);

		});
	});	
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slickslider"]) return;
  try {
    
$(document).ready(function(){
	$('.slider-outer1').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-practice"]) return;
  try {
    
$(document).ready(function(){
	alert();
   $('.slider-outer').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 2,
  autoplay: true,
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-with-video"]) return;
  try {
    
$(document).ready(function(){
  $('.slider-item-video').slick({
    centerMode: true,
  centerPadding: '60px',
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});
});

  } catch(e) { console.error(e); }
})();

})();
